<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent :max-width="`${MaxWidth}px`">
      <v-card>
        <v-card-title>
          <span class="headline"
            ><v-icon>{{ icon }}</v-icon> {{ title }}</span
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text> </v-card-text>
        <v-card-text>
          <v-sheet class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block">
            <div class="red--text text--lighten-1 text-body-3 mb-4">
              {{ text }}
            </div>
            <v-btn
              class="ma-1"
              :color="color"
              plain
              outlined
              @click="confirm()"
            >
              {{ butttonText }}
            </v-btn>
          </v-sheet>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="close">
            {{ $t("btn.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: "ConfirmDialog",
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: () => "title",
    },
    icon: {
      type: String,
      default: () => "text",
    },
    text: {
      type: String,
      default: () => "text",
    },
    butttonText: {
      type: String,
      default: () => "Confirm",
    },
    color: {
      type: String,
      default: () => "error",
    },
    MaxWidth: {
      type: Number,
      default: () => 500,
    },
  },
  data() {
    return { data: {}, dialog: false };
  },
  methods: {
    openDialog(val) {
      this.dialog = true;
      this.data = val;
    },
    close() {
      this.dialog = false;
    },
    confirm() {
      this.dialog = false;
      this.$emit("confirm-dialog", this.data);
    },
  },
};
</script>
